import { combineReducers } from 'redux';
import adminEventRegistrantsEmailsReducer from './adminEventRegistrantsEmailsReducer';
import adminEventRegistrantsStatsReducer from './adminEventRegistrantsStatsReducer';

export default combineReducers({
  registrantsEmailsList: adminEventRegistrantsEmailsReducer,
  registrantsStats: adminEventRegistrantsStatsReducer,
});
